document.addEventListener('DOMContentLoaded', function () {
	// Поддержка как blog, так и archive
	const blogSection = document.querySelector('.section.blog');
	const archiveSection = document.querySelector('.section.archive');
	const section = blogSection || archiveSection;

	if (!section) return;

	// Определяем префикс классов в зависимости от найденной секции
	const prefix = archiveSection && !blogSection ? 'archive' : 'blog';

	const loadMoreBtn = section.querySelector(`.${prefix}__load-more`);
	const postsContainer = section.querySelector(`.${prefix}__posts`);
	const paginationNav = section.querySelector(`.${prefix}__pagination`);
	const btnText = loadMoreBtn ? loadMoreBtn.querySelector('.btn__text') : null;
	const btnLoader = loadMoreBtn
		? loadMoreBtn.querySelector('.btn__loader')
		: null;

	if (!loadMoreBtn || !postsContainer || !paginationNav) return;

	const postsPerPage = parseInt(section.dataset.postsPerPage) || 2;
	const totalPosts = parseInt(section.dataset.totalPosts) || 0;

	// Параметры архива для AJAX запроса
	const archiveType = section.dataset.archiveType || '';
	const archiveObjectId = section.dataset.archiveObjectId || '';
	const archiveTaxonomy = section.dataset.archiveTaxonomy || '';
	const archiveSlug = section.dataset.archiveSlug || '';

	function getCurrentLanguage() {
		if (typeof pll_current_language !== 'undefined') {
			return pll_current_language();
		}

		const langAttr = section.dataset.currentLang;
		if (langAttr) return langAttr;

		const bodyClasses = document.body.className.split(' ');
		const langClass = bodyClasses.find(cls => cls.startsWith('lang-'));
		if (langClass) {
			return langClass.replace('lang-', '');
		}

		return 'ru';
	}

	loadMoreBtn.addEventListener('click', loadMorePosts);

	// Обработчик кликов для пагинации (стрелки и цифры)
	paginationNav.addEventListener('click', function (e) {
		// Проверяем клик по стрелке
		const arrow = e.target.closest(`.${prefix}__nav-arrow`);
		if (arrow && arrow.tagName !== 'SPAN') {
			e.preventDefault();
			const page = parseInt(arrow.dataset.page);
			if (!page) return;

			loadPostsPage(page);
			return;
		}

		// Проверяем клик по номеру страницы
		const pageNumber = e.target.closest(`.${prefix}__page-number`);
		if (pageNumber) {
			e.preventDefault();
			const page = parseInt(pageNumber.dataset.page);
			if (!page) return;

			loadPostsPage(page);
		}
	});

	// Функция обновления пагинации
	function updatePagination(currentPage, totalPages) {
		// Обновляем активный номер страницы
		const pageNumbers = paginationNav.querySelectorAll(
			`.${prefix}__page-number`,
		);
		pageNumbers.forEach(page => {
			page.classList.remove(`${prefix}__page-number--active`);

			const pageNum = parseInt(page.dataset.page);
			if (pageNum === currentPage) {
				page.classList.add(`${prefix}__page-number--active`);
			}

			// Обновляем ссылку для каждого номера - убираем хеш из текущего URL
			const cleanUrl = window.location.href.replace(/#.*$/, '');
			page.href =
				updateQueryString(cleanUrl, 'paged', pageNum) +
				`#${prefix === 'blog' ? 'blog' : 'archive-page'}`;
		});

		// Обновляем стрелочки
		updateNavArrows(currentPage, totalPages);
	}

	// Функция обновления состояния стрелочек
	function updateNavArrows(currentPage, totalPages) {
		// Очищаем URL от хеша для корректного формирования ссылок
		const cleanUrl = window.location.href.replace(/#.*$/, '');

		// Стрелка "Назад" - ищем по родительскому контейнеру
		const prevArrow = paginationNav.querySelector(
			`.pagination-nav__arrow--prev, .${prefix}__nav-arrow--prev`,
		);
		if (prevArrow) {
			if (currentPage > 1) {
				// Если это span (disabled), превращаем в ссылку
				if (prevArrow.tagName === 'SPAN') {
					const newLink = document.createElement('a');
					newLink.className = `${prefix}__nav-arrow ${prefix}__nav-arrow--prev pagination-nav__arrow pagination-nav__arrow--prev`;
					newLink.href =
						updateQueryString(cleanUrl, 'paged', currentPage - 1) +
						`#${prefix === 'blog' ? 'blog' : 'archive-page'}`;
					newLink.setAttribute('data-page', currentPage - 1);

					// Добавляем атрибуты доступности в зависимости от языка
					const currentLang = getCurrentLanguage();
					const prevLabel =
						currentLang === 'en'
							? 'Previous page'
							: currentLang === 'kk'
								? 'Алдыңғы бет'
								: 'Предыдущая страница';
					newLink.setAttribute('aria-label', prevLabel);
					newLink.setAttribute('title', prevLabel);

					prevArrow.replaceWith(newLink);
				} else {
					// Обновляем существующую ссылку
					prevArrow.href =
						updateQueryString(cleanUrl, 'paged', currentPage - 1) +
						`#${prefix === 'blog' ? 'blog' : 'archive-page'}`;
					prevArrow.setAttribute('data-page', currentPage - 1);
					prevArrow.classList.remove(`${prefix}__nav-arrow--disabled`);
				}
			} else {
				// Если на первой странице, превращаем ссылку в span
				if (prevArrow.tagName === 'A') {
					const newSpan = document.createElement('span');
					newSpan.className = `${prefix}__nav-arrow ${prefix}__nav-arrow--prev ${prefix}__nav-arrow--disabled`;
					newSpan.setAttribute('aria-hidden', 'true');
					prevArrow.replaceWith(newSpan);
				}
			}
		}

		// Стрелка "Вперед" - ищем по родительскому контейнеру
		const nextArrow = paginationNav.querySelector(
			`.pagination-nav__arrow--next, .${prefix}__nav-arrow--next`,
		);
		if (nextArrow) {
			if (currentPage < totalPages) {
				if (nextArrow.tagName === 'SPAN') {
					const newLink = document.createElement('a');
					newLink.className = `${prefix}__nav-arrow ${prefix}__nav-arrow--next pagination-nav__arrow pagination-nav__arrow--next`;
					newLink.href =
						updateQueryString(cleanUrl, 'paged', currentPage + 1) +
						`#${prefix === 'blog' ? 'blog' : 'archive-page'}`;
					newLink.setAttribute('data-page', currentPage + 1);

					const currentLang = getCurrentLanguage();
					const nextLabel =
						currentLang === 'en'
							? 'Next page'
							: currentLang === 'kk'
								? 'Келесі бет'
								: 'Следующая страница';
					newLink.setAttribute('aria-label', nextLabel);
					newLink.setAttribute('title', nextLabel);

					nextArrow.replaceWith(newLink);
				} else {
					nextArrow.href =
						updateQueryString(cleanUrl, 'paged', currentPage + 1) +
						`#${prefix === 'blog' ? 'blog' : 'archive-page'}`;
					nextArrow.setAttribute('data-page', currentPage + 1);
					nextArrow.classList.remove(`${prefix}__nav-arrow--disabled`);
				}
			} else {
				if (nextArrow.tagName === 'A') {
					const newSpan = document.createElement('span');
					newSpan.className = `${prefix}__nav-arrow ${prefix}__nav-arrow--next ${prefix}__nav-arrow--disabled`;
					newSpan.setAttribute('aria-hidden', 'true');
					nextArrow.replaceWith(newSpan);
				}
			}
		}
	}

	async function loadMorePosts() {
		const currentPage = parseInt(loadMoreBtn.dataset.page) || 1;

		if (btnText && btnLoader) {
			btnText.style.opacity = '0.5';
			btnLoader.style.display = 'block';
		}

		loadMoreBtn.disabled = true;

		try {
			// Проверка наличия глобального объекта от wp_localize_script
			if (typeof posts_vars === 'undefined' || !posts_vars.ajaxurl) {
				throw new Error('Переменная posts_vars не определена. Проверьте wp_localize_script в PHP.');
			}

			const response = await fetch(posts_vars.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'load_more_posts',
					nonce: posts_vars.nonce,
					page: currentPage,
					posts_per_page: postsPerPage,
					current_lang: getCurrentLanguage(),
					archive_type: archiveType,
					archive_object_id: archiveObjectId,
					archive_taxonomy: archiveTaxonomy,
					archive_slug: archiveSlug,
				}),
			});

			// Получаем сырой текст ответа сервера
			const responseText = await response.text();

			// Проверяем HTTP статус (404, 500 и т.д.)
			if (!response.ok) {
				console.error('Сервер вернул ошибку:', response.status, responseText);
				throw new Error(`HTTP ошибка! Статус: ${response.status}. Ответ сервера в консоли.`);
			}

			// Пытаемся распарсить JSON вручную, чтобы поймать SyntaxError
			let data;
			try {
				data = JSON.parse(responseText);
			} catch (e) {
				console.error('Сервер вернул НЕ JSON. Ответ сервера:', responseText);
				throw new Error('Сервер вернул некорректный ответ (скорее всего, ошибка PHP). Смотрите консоль (F12).');
			}

			if (data.success) {
				// Добавляем новые посты (для кнопки "Загрузить ещё")
				postsContainer.insertAdjacentHTML('beforeend', data.data.html);

				// Обновляем номер следующей страницы на кнопке
				if (data.data.next_page) {
					loadMoreBtn.dataset.page = data.data.next_page;
				} else {
					// Скрываем кнопку, если больше нет страниц
					loadMoreBtn.style.display = 'none';
				}

				// Обновляем пагинацию с новыми данными
				updatePagination(data.data.current_page, data.data.total_pages);

				// Обновляем data-атрибуты в секции
				section.dataset.currentPage = data.data.current_page;
				section.dataset.totalPages = data.data.total_pages;
				section.dataset.totalPosts = data.data.total_posts;

				// Плавная прокрутка к последнему загруженному посту
				const newCards = postsContainer.querySelectorAll('.js-article-card');

				if (newCards.length > 0) {
					const lastNewCard = newCards[newCards.length - postsPerPage];
					if (lastNewCard) {
						lastNewCard.scrollIntoView({
							behavior: 'smooth',
							block: 'nearest',
						});
					}
				}
			} else {
				console.error('Логическая ошибка AJAX (data.success === false):', data.data);
				showError('Ошибка на сервере: ' + (data.data || 'Неизвестная ошибка'));
			}
		} catch (error) {
			console.error('Детали ошибки:', error);
			// Показываем реальную ошибку, а не заглушку
			showError(error.message || 'Произошла неизвестная ошибка');
		} finally {
			if (btnText && btnLoader) {
				btnText.style.opacity = '1';
				btnLoader.style.display = 'none';
			}

			loadMoreBtn.disabled = false;
		}
	}

	// Функция загрузки конкретной страницы (для пагинации)
	async function loadPostsPage(page) {
		if (btnText && btnLoader) {
			btnText.style.opacity = '0.5';
			btnLoader.style.display = 'block';
		}

		loadMoreBtn.disabled = true;

		try {
			// Проверка наличия глобального объекта от wp_localize_script
			if (typeof posts_vars === 'undefined' || !posts_vars.ajaxurl) {
				throw new Error('Переменная posts_vars не определена. Проверьте wp_localize_script в PHP.');
			}

			const response = await fetch(posts_vars.ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'load_more_posts',
					nonce: posts_vars.nonce,
					page: page,
					posts_per_page: postsPerPage,
					current_lang: getCurrentLanguage(),
					archive_type: archiveType,
					archive_object_id: archiveObjectId,
					archive_taxonomy: archiveTaxonomy,
					archive_slug: archiveSlug,
				}),
			});

			// Получаем сырой текст ответа сервера
			const responseText = await response.text();

			// Проверяем HTTP статус (404, 500 и т.д.)
			if (!response.ok) {
				console.error('Сервер вернул ошибку:', response.status, responseText);
				throw new Error(`HTTP ошибка! Статус: ${response.status}. Ответ сервера в консоли.`);
			}

			// Пытаемся распарсить JSON вручную, чтобы поймать SyntaxError
			let data;
			try {
				data = JSON.parse(responseText);
			} catch (e) {
				console.error('Сервер вернул НЕ JSON. Ответ сервера:', responseText);
				throw new Error('Сервер вернул некорректный ответ (скорее всего, ошибка PHP). Смотрите консоль (F12).');
			}

			if (data.success) {
				// Очищаем контейнер и добавляем посты для выбранной страницы
				postsContainer.innerHTML = data.data.html;

				// Обновляем номер следующей страницы на кнопке
				if (data.data.next_page) {
					loadMoreBtn.dataset.page = data.data.next_page;
					loadMoreBtn.style.display = '';
				} else {
					loadMoreBtn.style.display = 'none';
				}

				// Обновляем пагинацию
				updatePagination(data.data.current_page, data.data.total_pages);

				// Обновляем data-атрибуты в секции
				section.dataset.currentPage = data.data.current_page;
				section.dataset.totalPages = data.data.total_pages;
				section.dataset.totalPosts = data.data.total_posts;

				// Обновляем URL без перезагрузки
				let newUrl;
				// Сначала убираем хеш и параметры customize_changeset_uuid
				const cleanUrl = window.location.href
					.replace(/#.*$/, '') // убираем всё после #
					.replace(/[?&]customize_changeset_uuid=[^&]*/g, ''); // убираем customize_changeset_uuid

				if (page === 1) {
					// Для первой страницы убираем параметр paged из URL
					newUrl = cleanUrl.replace(/[?&]paged=\d+/, '');
					// Убираем лишние символы в конце, если нужно
					newUrl = newUrl.replace(/[?&]$/, '');
				} else {
					newUrl = updateQueryString(cleanUrl, 'paged', page);
				}
				history.pushState(
					{ page: page },
					'',
					newUrl + `#${prefix === 'blog' ? 'blog' : 'archive-page'}`,
				);

				// Плавная прокрутка к первому посту
				const firstCard = postsContainer.querySelector(
					`.${prefix}__article-card`,
				);
				if (firstCard) {
					firstCard.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});
				}
			} else {
				console.error('Логическая ошибка AJAX (data.success === false):', data.data);
				showError('Ошибка на сервере: ' + (data.data || 'Неизвестная ошибка'));
			}
		} catch (error) {
			console.error('Детали ошибки:', error);
			// Показываем реальную ошибку, а не заглушку
			showError(error.message || 'Произошла неизвестная ошибка');
		} finally {
			if (btnText && btnLoader) {
				btnText.style.opacity = '1';
				btnLoader.style.display = 'none';
			}

			loadMoreBtn.disabled = false;
		}
	}

	function updateQueryString(uri, key, value) {
		const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
		const separator = uri.includes('?') ? '&' : '?';

		if (uri.match(re)) {
			return uri.replace(re, `$1${key}=${value}$2`);
		}
		return `${uri}${separator}${key}=${value}`;
	}

	function showError(message) {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'blog__error';
		errorDiv.style.cssText = `
			padding: 15px;
			margin: 10px 0;
			background: #fee;
			border: 1px solid #fcc;
			border-radius: 4px;
			color: #c00;
			text-align: center;
		`;
		errorDiv.textContent = message;

		loadMoreBtn.parentNode.insertBefore(errorDiv, loadMoreBtn.nextSibling);
		setTimeout(() => errorDiv.remove(), 5000);
	}

	// Инициализация пагинации при загрузке страницы
	const initialPage = parseInt(section.dataset.currentPage) || 1;
	const initialTotalPages = parseInt(section.dataset.totalPages) || 1;
	updatePagination(initialPage, initialTotalPages);
});
